<template>
  <b-container>
    <b-form @submit="onSubmit">
      <div v-if="success" class="pt-4">
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </div>
      <div v-else>
        <b-row>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.taskTitle") }}</strong>
            </div>
            <b-form-input v-model.trim="$v.form.taskTitle.$model" :placeholder="$t('label.taskTitle')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.taskTitle.required && $v.form.taskTitle.$dirty">
              {{ $t("info.required") }}
            </div>
          </b-col>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.dueDateTime") }}</strong>
            </div>
            <datepicker input-class="datepicker" v-model="form.dueDateTime" :placeholder="$t('action.chooseDate')"
              :language="language" :disabledDates="disabledDate"></datepicker>

            <div class="text-danger" v-if="!$v.form.dueDateTime.required && $v.form.dueDateTime.$dirty">
              {{ $t("info.required") }}
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.bucketList") }}</strong>
            </div>
            <b-form-select v-model="form.bucketSelect" :options="bucketList">
            </b-form-select>
          </b-col>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.priorityLevel") }}</strong>
            </div>
            <b-form-select v-model="form.priority" :options="priorityList">
            </b-form-select>
            <div class="text-danger" v-if="!$v.form.priority.required && $v.form.priority.$dirty">
              {{ $t("info.required") }}
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.labelList") }}</strong>
            </div>
            <b-form-select v-model="form.labelSelect" :options="labelList" multiple size="sm"></b-form-select>
            <div>
              <small>&#9432; {{ $t("info.chooseMultiple") }}</small>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-checkbox class="mt-4" v-model="recurrence" name="recurrence-checkbox">{{
              $t("action.setRecurrence") }}</b-form-checkbox>
          </b-col>
        </b-row>

        <div v-if="recurrence">
          <b-row>
            <b-col sm="6">
              <div class="mt-4">
                <strong>{{ $t("action.chooseStartDate") }}</strong>
              </div>
              <datepicker input-class="datepicker" v-model="form.startDate" :placeholder="$t('action.chooseStartDate')"
                :language="language" :disabledDates="disabledDate"></datepicker>

              <div class="text-danger" v-if="!$v.form.startDate.required && $v.form.startDate.$dirty">
                {{ $t("info.required") }}
              </div>
            </b-col>
          </b-row>

          <b-row v-if="form.startDate">
            <b-col sm="6">
              <div class="mt-4">
                <strong>{{ $t("action.chooseFrequency") }}</strong>
              </div>
              <b-form-select v-model="form.frequency" :options="frequencyList" v-on:change="OnFrequencyClick">
              </b-form-select>
              <div class="text-danger" v-if="!$v.form.frequency.required && $v.form.frequency.$dirty">
                {{ $t("info.required") }}
              </div>
            </b-col>
            <!-- <b-col sm="6">
              <div class="mt-4">
                <strong>{{ $t("action.chooseInterval") }}</strong>
              </div>
              <b-form-select v-model="form.interval" :options="intervalList">
              </b-form-select>
              <div class="text-danger" v-if="!$v.form.interval.required && $v.form.interval.$dirty">
                {{ $t("info.required") }}
              </div>
            </b-col>-->
          </b-row>

          <b-row v-if="form.startDate && form.frequency === 'day'">
            <b-col sm="6">
              <div class="mt-4">
                <strong>{{ $t("action.chooseInterval") }}</strong>
              </div>
              <b-form-select v-model="form.interval" :options="generateNumberList(7)"></b-form-select>
              <div class="mt-4">{{ displayRecurrencePattern(form.interval, form.frequency, form.startDate) }}</div>
            </b-col>
          </b-row>

          <b-row v-if="form.startDate && form.frequency === 'week'">
            <b-col sm="6" class="mt-4">
              <div>
                <strong>{{ $t("action.chooseInterval") }}</strong>
              </div>
              <b-form-select v-model="form.interval" :options="generateNumberList(31)">
              </b-form-select>

              <b-form-group v-slot="{ ariaDescribedby }" class="mt-4">
                <b-form-checkbox-group id="dayOfWeekPicker" v-model="form.dayOfWeekPickerList"
                  :aria-describedby="ariaDescribedby" name="dayOfWeekPickerList">
                  <!-- sunday, monday, tuesday, wednesday, thursday, friday, saturday-->
                  <b-form-checkbox value="sunday">{{ $t("label.sunday") }}</b-form-checkbox>
                  <b-form-checkbox value="monday">{{ $t("label.monday") }}</b-form-checkbox>
                  <b-form-checkbox value="tuesday">{{ $t("label.tuesday") }}</b-form-checkbox>
                  <b-form-checkbox value="wednesday">{{ $t("label.wednesday") }}</b-form-checkbox>
                  <b-form-checkbox value="thursday">{{ $t("label.thursday") }}</b-form-checkbox>
                  <b-form-checkbox value="friday">{{ $t("label.friday") }}</b-form-checkbox>
                  <b-form-checkbox value="saturday">{{ $t("label.saturday") }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
              <div class="mt-4">{{ displayRecurrencePattern(form.interval, form.frequency, form.startDate,
                form.dayOfWeekPickerList) }}</div>
            </b-col>
          </b-row>

          <b-row v-if="form.frequency && (form.frequency === 'month' || form.frequency === 'year') && form.startDate">
            <b-col sm="6">
              <div class="mt-4">
                <strong>{{ $t("action.chooseInterval") }}</strong>
              </div>
              <b-form-select v-model="form.interval" :options="generateNumberList(12)">
              </b-form-select>
              <div class="mt-4">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="form.dayType" :aria-describedby="ariaDescribedby" name="date" value="date">{{
                    $t("action.specificDate") }} : {{ displayDateInfo(form.startDate, 'DD') }} </b-form-radio>
                  <b-form-radio v-model="form.dayType" :aria-describedby="ariaDescribedby" name="day" value="day">{{
                    $t("action.dayOfWeek") }} : {{ displayDateInfo(form.startDate, 'dddd') }}</b-form-radio>
                </b-form-group>
                <div v-if="form.dayType === 'day'">
                  <b-form-select v-model="form.weekIndex" :options="weekIndexList">
                  </b-form-select>
                  <div class="mt-4">{{ displayRecurrencePattern(form.interval, form.frequency,
                    displayDateInfo(form.startDate, 'dddd'),
                    null, form.dayType, form.weekIndex) }}</div>
                </div>
                <div v-else class="mt-4">{{ displayRecurrencePattern(form.interval, form.frequency,
                  displayDateInfo(form.startDate, 'DD'), null, form.dayType, form.weekIndex) }}</div>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-card no-body class="mb-1 mt-4">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">{{
              $t("info.groupSelectForTaskAssignment")
            }}</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form-select v-model="grouping" :options="groupingList" v-on:change="OnGroupingClick"></b-form-select>
              <div v-if="grouping">
                <ChooseMemberAssignment :key="componentKey" :groupingItem="grouping" />
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-button class="mt-4 text-center" type="submit" variant="success" :disabled="disabled">{{
          $t("action.confirmed")
        }}</b-button>

        <div v-if="errorList.length > 0" class="pt-4">
          <b-alert show variant="danger">
            <p>{{ errorList }}</p>
          </b-alert>
        </div>
      </div>
    </b-form>
    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning"
        disabled="labelStatus"></b-spinner>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import { required } from "vuelidate/lib/validators";
import ChooseMemberAssignment from "./ChooseMemberAssignment.vue";

import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["teamSelect", "modalid"],
  data: () => ({
    form: {
      taskTitle: "",
      dueDateTime: "",
      priority: null,
      bucketSelect: null,
      labelSelect: [],
      startDate: "",
      frequency: null,
      interval: 1,
      dayInterval: 1,
      dayType: "date",
      dayOfWeekPickerList: [],
      dayOfMonth: 1,
      weekIndex: "first"
    },
    groupList: [],
    disabled: false,
    success: false,
    error: "",
    spinner: false,
    errorList: [],
    grouping: null,
    componentKey: 0,
    recurrence: false
  }),
  validations() {
    let form = {
      taskTitle: {
        required,
      },
      dueDateTime: {
        required,
      },
      priority: {
        required,
      },
    };

    if (this.recurrence) {
      form.startDate = {
        required
      },
        form.dayType = {
          required
        },
        form.frequency = {
          required
        },
        form.interval = {
          required
        }
    }

    return { form };
  },
  mounted() {
    //this.getGroupList();
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    },
    language: function () {
      return this.$i18n.locale === "fr" ? fr : en;
    },
    disabledDate: function () {
      let myDate = moment().startOf("day").toDate();
      return { to: myDate };
    },
    priorityList: function () {
      return this.$t("info.taskPriority");
    },
    bucketList: function () {
      let plannerBucket = this.getGlobalData("plannerBucket");
      let lg = this.$i18n.locale;

      let bucketList = plannerBucket.map((p) => {
        let appLg = lg === "fr" ? p.fr : p.en;
        return { value: p.Id, text: appLg };
      });
      bucketList.unshift({
        value: null,
        text: this.$t("action.chooseBucket"),
      });
      return bucketList;
    },
    labelList: function () {
      let plannerLabel = this.getGlobalData("plannerLabel");
      let lg = this.$i18n.locale;

      let labelList = plannerLabel.map((p) => {
        let appLg = lg === "fr" ? p.fr : p.en;
        return { value: p.value, text: appLg };
      });
      return labelList;
    },
    groupingList: function () {
      let groupingList = this.teamSelect.map(g => {
        return {
          text: g.GroupingName,
          value: g
        }
      })

      groupingList.unshift({ value: null, text: this.$t('action.choose') });
      return groupingList;
    },
    frequencyList: function () {
      return [
        { text: this.$t('action.chooseFrequency'), value: null },
        { text: this.$t('action.byDay'), value: "day" },
        { text: this.$t('action.byWeek'), value: "week" },
        { text: this.$t('action.byMonth'), value: "month" },
        { text: this.$t('action.byYear'), value: "year" }
      ]
    },
    weekIndexList: function () {
      //first, second, third, fourth, last
      return [
        { text: this.$t('label.first'), value: "first" },
        { text: this.$t('label.second'), value: "second" },
        { text: this.$t('label.third'), value: "third" },
        { text: this.$t('label.fourth'), value: "fourth" },
        { text: this.$t('label.last'), value: "last" }
      ]
    },
    intervalList: function () {
      return [
        { text: this.$t('action.chooseInterval'), value: null },
        { text: 1, value: 1 },
        { text: 2, value: 2 },
        { text: 3, value: 3 },
        { text: 4, value: 4 },
        { text: 5, value: 5 },
        { text: 6, value: 6 }
      ]
    },
    microsoftPatternType: function () {
      let microsoftPatternType = null;
      if (this.form.frequency && this.form.dayType && this.form.startDate && this.form.interval) {
        let int = this.form.interval;
        let freq = this.form.frequency;
        let dayType = this.form.dayType;

        let infoDateType = dayType === "date" ? this.displayDateInfo(this.form.startDate, 'DD') :
          this.displayDateInfo(this.form.startDate, 'dddd');

        let daysOfWeek = this.form.dayOfWeekPickerList.length > 0 ? this.form.dayOfWeekPickerList : [infoDateType.toLowerCase()];
        
        let month = moment(this.form.startDate).month() + 1;

        if (freq === 'day') {
          microsoftPatternType = {
            type: "daily",
            interval: int
          };
        }

        if (freq === 'week') {
          infoDateType = this.displayDateInfo(this.form.startDate, 'dddd');
          daysOfWeek = this.form.dayOfWeekPickerList.length > 0 ? this.form.dayOfWeekPickerList : [infoDateType.toLowerCase()];
        }

        if (freq === 'week') {
          //Une journée de la semaine (Mercredi) à toutes les semaines (selon fréquence)
            microsoftPatternType = {
              type: "weekly",
              interval: int,
              daysOfWeek: daysOfWeek,
              firstDayOfWeek: "monday"
            };
        }

        if (freq === 'month') {
          //Une date précise (le 15) à tous les mois (selon fréquence)
          if (dayType === "date") {
            microsoftPatternType = {
              type: "absoluteMonthly",
              interval: int,
              dayOfMonth: parseInt(infoDateType),
            };
          }
          //Une journée de la semaine (Mercredi) à tous les mois (selon fréquence)
          if (dayType === "day") {
            microsoftPatternType = {
              type: "relativeMonthly",
              interval: int,
              daysOfWeek: [infoDateType.toLowerCase()],
              index: this.form.weekIndex
            };
          }
        }

        if (freq === 'year') {
          if (dayType === "date") {
            //Une date précise (le 15) à tous les mois (selon fréquence)
            microsoftPatternType = {
              type: "absoluteYearly",
              interval: int,
              dayOfMonth: parseInt(infoDateType),
              month: month
            };
          }
          //Une journée de la semaine (Mercredi)
          if (dayType === "day") {
            microsoftPatternType = {
              type: "relativeYearly",
              interval: int,
              daysOfWeek: [infoDateType.toLowerCase()],
              month: month,
              index: this.form.weekIndex
            };
          }
        }
      }
      return microsoftPatternType;
    }
  },
  methods: {
    OnFrequencyClick: function (value) {
      if (value === 'week') {
        this.form.dayType = 'day';
      }

      this.form.interval = 1;
      this.form.dayInterval = 1;
      this.form.dayType = "date";
      this.form.dayOfWeekPickerList = [];
      this.form.dayOfMonth = 1;
      this.form.weekIndex = "first";

    },
    displayDateInfo: function (date, format) {
      return moment(date).format(format);
    },
    getItemByLg(list, value) {
      return list.find(f => f.value === value).text;
    },
    displayRecurrencePattern: function (interval, frequency, startDate, dayOfWeekPickerList, dayType, weekIndex) {
      let lg = this.$i18n.locale;
      //let frequencyValue = this.getItemByLg(this.frequencyList, frequency);
      let info = "";
      if (frequency === 'day') {
        if (lg === 'en') {
          info = `Every ${interval} ${frequency} starting from ${moment(startDate).format('DD-MM-YYYY')}`;
        }
        else {
          info = `À tous les ${interval} jour(s) à partir du ${moment(startDate).format('DD-MM-YYYY')}`;
        }
      }
      else if (frequency === 'week') {
        if (lg === 'en') {
          info = `Every ${interval} ${frequency} `;
          if (dayOfWeekPickerList && dayOfWeekPickerList.length > 0) {
            info += `on ${dayOfWeekPickerList.toString()} `;
          }
          info += `starting from ${moment(startDate).format('DD-MM-YYYY')}`;
        }
        else {
          info = `À tous les ${interval} semaine(s) `;
          if (dayOfWeekPickerList && dayOfWeekPickerList.length > 0) {
            info += `les ${dayOfWeekPickerList.toString()} `;
          }
          info += `à partir du ${moment(startDate).format('DD-MM-YYYY')}`;
        }
      }
      else {
        if (lg === 'en') {
          if (dayType === 'day') {
            info = `Every ${interval} ${frequency} starting from the ${weekIndex} ${startDate}`;
          }
          else {
            info = `Every ${interval} ${frequency} starting from the ${startDate}`;
          }
        }
        else {
          if (dayType === 'day') {
            info = `À tous les ${interval} mois/année(s) à partir du ${weekIndex} ${startDate}`;
          }
          else {
            info = `À tous les ${interval} mois/année(s) à partir du ${startDate}`;
          }
        }
      }

      return info;
    },
    getNumberOfDaysByMonth: function (date) {
      return moment(date).daysInMonth();
    },
    generateNumberList: function (max) {
      let min = 1;
      //let max = moment(date).daysInMonth();
      let list = [];
      for (let i = min; i <= max; i++) {
        list.push({
          text: i,
          value: i
        });
      }
      return list;
    },
    OnGroupingClick: function () {
      this.componentKey += 1;
    },
    //BUILD GROUP WITH PLAN AND BUCKET
    getGroupList() {
      this.spinner = true;
      let teamSelect = this.teamSelect;
      let token = this.getGlobalData("accessToken");
      let requestMemberOf = [];
      let requestPlans = [];
      let requestBuckets = [];
      let planId = null;

      for (let i = 0; i < teamSelect.length; i++) {
        let groupId = teamSelect[i].GroupId;
        requestPlans.push(this.getGroupPlan(token, groupId));
      }

      //get plans of Group
      Promise.allSettled(requestPlans).then((results) => {
        //set plans group
        teamSelect = this.setGroupPlan(results, teamSelect);

        for (let i = 0; i < teamSelect.length; i++) {
          let groupId = teamSelect[i].GroupId;
          requestMemberOf.push(this.getMemberOf(token, groupId));
        }

        //get plan details
        Promise.allSettled(requestMemberOf).then((results) => {
          //set plan details
          teamSelect = this.setMemberOf(results, teamSelect);

          for (let i = 0; i < teamSelect.length; i++) {
            let plansOfGroup = teamSelect[i].plansOfGroup;
            let plan = plansOfGroup[0];
            planId = plan.id;
            requestBuckets.push(this.getPlanBuckets(token, planId));
          }

          Promise.allSettled(requestBuckets).then((results) => {
            //set plan bucket
            teamSelect = this.setPlanBucket(results, teamSelect);

            //set group list
            if (this.errorList.length > 0) {
              this.error = this.errorList;
            } else {
              this.groupList = teamSelect;
            }

            this.spinner = false;
          });
        });
      });
    },
    getGroupPlan(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/planner/plans`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setGroupPlan(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");
      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let plansOfGroup = successList[i].value.data.value;
          teamSelect[i].plansOfGroup = plansOfGroup;
        }
      }
      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        this.errorList.push(errorList);
        this.logError(errorList);
      }
      return teamSelect;
    },
    getMemberOf(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          ConsistencyLevel: "eventual",
        },
      });
    },
    setMemberOf(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");
      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let memberOfGroup = successList[i].value.data.value;
          teamSelect[i].memberSelect = [];
          teamSelect[i].memberOfGroup = memberOfGroup;
        }
      }
      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        this.errorList.push(errorList);
        this.logError(errorList);
      }
      return teamSelect;
    },
    getPlanBuckets(token, planId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/plans/${planId}/buckets`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setPlanBucket(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");

      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let bucketOfPlans = successList[i].value.data.value;
          //teamSelect[i].bucketSelect = null; //bucketOfPlans[0].id;
          teamSelect[i].bucketOfPlans = bucketOfPlans;
          //teamSelect[i].labelSelect = null;
        }
      }

      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        this.errorList.push(errorList);
        this.logError(errorList);
      }
      return teamSelect;
    },
    setMemberOfGroupSelect(list) {
      let memberOf = list.map((item) => {
        return {
          value: item.id,
          text: item.displayName,
        };
      });
      return memberOf;
    },
    //Set bucket b-form-select
    setBucket(list) {
      let bucketList = list.map((item) => {
        return {
          value: item.id,
          text: item.name,
        };
      });

      bucketList.unshift({
        value: null,
        text: this.$t("action.chooseBucket"),
      });

      return bucketList;
    },
    //CREATE TASK AND LOG
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.spinner = true;
        this.disabled = true;
        //let jobData = [];
        let groupList = this.teamSelect;
        let groupMembers = this.$store.getters.getGroupMemberTest;
        let groupListMap = groupList.map(g => {
          g.assignments = [];
          return g;
        })

        let groupListWithMembers = this.getJobDataArr(groupListMap, groupMembers);

        let groupListForScheduleJob = groupListWithMembers.map(g => {
          g.taskTitle = this.form.taskTitle;
          g.bucketSelect = this.form.bucketSelect;
          g.appliedCategories = this.getLabelCategory();
          g.dueDateTime = moment.utc(this.form.dueDateTime).format();
          g.priority = this.form.priority;
          return g;
        });

        /*for (let i = 0; i < groupList.length; i++) {
          let membersAssignToTask = this.getMemberAssignToTask(
            groupList[i].membersList
          );

          let bucketSelect = this.getBucketSelect(groupList[i].Language);

          let body = {
            title: this.form.taskTitle,
            priority: this.form.priority,
            assignments: membersAssignToTask,
            appliedCategories: this.getLabelCategory(),
            idGroupBuilding: groupList[i].Id,
            groupId: groupList[i].GroupId,
            bucketSelect: bucketSelect,
            planId: groupList[i].PlanId,
          };

          if (this.form.dueDateTime) {
            body.dueDateTime = moment.utc(this.form.dueDateTime).format();
          }

          jobData.push(body);
        }*/

        let scheduleJobObj = {
          request: "startTaskJobForGrouping",
          jobName: "GroupingTaskAssignment",
          taskTitle: this.form.taskTitle,
          jobData: groupListForScheduleJob,
          destination: this.getDestinationByUserRole(this.user.role),
          user: this.user.Id,
          recurrence: this.recurrence ? this.getRecurrenceObj() : null
        };

        axios
          .post(this.url, scheduleJobObj, {
            headers: { "Content-Type": "application/json" },
          })
          .then(() => {
            this.success = true;
            this.spinner = false;
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      }
    },
    getJobDataArr(groupList, groupMembers) {

      for (let i = 0; i < groupMembers.length; i++) {
        let groupMember = groupMembers[i];
        let ind = groupList.findIndex(g => g.Id === groupMember.groupingItem.Id);
        if (ind !== -1) {
          groupMember.rowItem.membersList = this.getMemberAssignToTask(groupMember.members);
          groupList[ind].assignments.push(groupMember.rowItem);
        }
      }

      return groupList;
    },
    getRecurrenceObj() {

      let obj = {
        "recurrence": {
          "schedule": {
            "pattern": this.microsoftPatternType,
            "patternStartDateTime": moment.utc(this.form.startDate).format()
          }
        },
        "dueDateTime": moment.utc(this.form.startDate).format()
      }

      return obj;

    },
    getBucketSelect(language) {
      let bucketSelect = this.form.bucketSelect;
      let plannerBucket = this.getGlobalData("plannerBucket");
      let bucketObj = plannerBucket.find((b) => b.Id === bucketSelect);
      return language === 'fr' ? bucketObj.fr : bucketObj.en;
    },
    getMemberAssignToTask(memberSelect) {
      let assignments = {};

      if (memberSelect.length > 0) {
        for (let i = 0; i < memberSelect.length; i++) {
          Object.assign(assignments, {
            [memberSelect[i].id]: {
              "@odata.type": "#microsoft.graph.plannerAssignment",
              orderHint: " !",
            },
          });
        }
      }
      else {
        assignments = null;
      }

      return assignments;
    },
    getLabelCategory() {
      let labelSelect = this.form.labelSelect;
      let returnVal = null;
      if (labelSelect.length > 0) {
        let labelCategory = {};
        for (let i = 0; i < labelSelect.length; i++) {
          Object.assign(labelCategory, {
            [labelSelect[i]]: true,
          });
        }
        returnVal = labelCategory;
      }
      return returnVal;
    },
    getBucketId(bucketOfPlans) {
      let bucketId = bucketOfPlans[0].id;
      let bucketSelect = this.form.bucketSelect;
      let find = bucketOfPlans.find(
        (b) => b.name.replace(/\W/gi, "").toLowerCase() === bucketSelect
      );
      if (find) {
        bucketId = find.id;
      }
      return bucketId;
    },
    createTask(token, body) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/tasks`;
      return axios.post(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    logError(errorList) {
      let obj = {
        request: "logError",
        jobName: "ConfirmedTaskAssignment",
        errorList: errorList,
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
  components: {
    Datepicker,
    ChooseMemberAssignment
  },
};
</script>
